import { loadJwt } from "../dwclient/localstorage/jwtStorage";
import { readFileJwtAsReadable } from "../dwclient/dwstorage";

export const utilSingleFileDownload = async (
  selectedWallet,
  node,
  mainDirectoryHandle,
  onDownloadProgress,
  signal,
) => {
  //console.log("singleFileDownload");
  /*const result = await readFile(
      selectedWallet?.provider,
      storageProps,
      node.properties.fileStorageId,
      node.properties?.fileSize,
      onDownloadProgress,
    );
    downloadFile(result, node.value);*/
  //const { readable, writable } = new TransformStream();
  const authToken = (await loadJwt()) ?? "";
  const progressData = {
    fileId: node.properties.fileStorageId,
    status: "downloading",
    loadedFiles: 0,
    totalFiles: 1,
    loadedFilesBytes: 0,
    totalFilesBytes: node.properties?.fileSize,
    size: node.properties?.fileSize,
  };
  const readable = await readFileJwtAsReadable(
    //const readable = await readFileInChunksAsReadableStream(
    selectedWallet?.provider,
    authToken,
    node.properties.fileStorageId,
    node.properties.fileSize,
    progressData,
    onDownloadProgress,
    signal,
  );
  /*const response = new Response(readable, {
      headers: {
        "Content-Type": node.properties?.fileMimeType,
        "Content-Disposition": `attachment; filename="${node.properties?.fileName}"`,
      },
    });*/
  if (window.showDirectoryPicker) {
    //const mainDirectoryHandle = await window.showDirectoryPicker({ mode: "readwrite" });
    const fileHandle = await mainDirectoryHandle.getFileHandle(node.properties?.fileName, { create: true });
    const writable = await fileHandle.createWritable();
    await readable.pipeTo(writable, { signal });
  } else {
    // Fallback to write blob and then download

    // Create a temporary array to hold stream data
    const partBlobs = [];

    // Consume the stream and push chunks to the array
    const reader = readable.getReader();
    const cancelReader = () => {
      void reader.cancel(signal?.reason).catch(() => {});
    };
    if (signal?.aborted) {
      cancelReader();
      signal.throwIfAborted();
    }
    signal?.addEventListener("abort", cancelReader, { once: true });
    let done, value;

    try {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        signal?.throwIfAborted();
        ({ done, value } = await reader.read());
        signal?.throwIfAborted();
        if (done) break;
        const partBlob = new Blob([value], { type: "application/octet-stream" });
        partBlobs.push(partBlob);
      }
    } finally {
      signal?.removeEventListener("abort", cancelReader);
    }

    signal?.throwIfAborted();
    // Convert the chunks to a Blob
    const blob = new Blob(partBlobs, { type: node.properties?.fileType });

    signal?.throwIfAborted();
    // Create object URL
    const url = URL.createObjectURL(blob);
    // Create and trigger the download link
    const a = document.createElement("a");
    a.href = url;
    a.download = node.properties?.fileName;
    document.body.appendChild(a);
    signal?.throwIfAborted();
    a.click();

    // Cleanup
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.remove();
    }, 100);
  }
  return []; // errorFilePathList: not implemented
};
